import React, { useCallback } from 'react';
import {Link as MuiLink, Theme} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { push, replace} from 'connected-react-router';
import {createStyles, makeStyles} from "@material-ui/styles";
import clsx from 'clsx';

type Props = Omit<React.ComponentProps<typeof MuiLink>, 'href' | 'target'> & {
  to?: string;
  replace?: boolean;
  target?: '_self' | '_blank' | '_top';
  defaultAction?: boolean;
  styleType?: 'primary' | 'secondary';
  disabled?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    color: palette.link.color,
    outline: 'unset',
  },
  secondary: {
    color: '#EB5545',
  },
  disabled: {
    color: '#747C99',
    textDecoration: 'none !important',
  },
}), { name: 'Link' });

const Link = ({
  to,
  replace: shouldReplace = false,
  children,
  target = '_self',
  onClick,
  defaultAction = false,
  styleType = 'primary',
  disabled = false,
  ...props
}: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {

    if (disabled) {
      return;
    }

    if (onClick) {
      onClick(e);
    }

    if (!e.defaultPrevented && to && !defaultAction) {
      dispatch(shouldReplace ? replace(to) : push(to));
    }
    if (!defaultAction) {
      e.preventDefault();
    }
  }, [onClick, dispatch, shouldReplace, to, defaultAction, disabled]);

  return (
    <MuiLink
      tabIndex={-1}
      href={disabled ? undefined : (to || '#')}
      target={target}
      onClick={handleClick}
      classes={{
        root: classes.root,
      }}
      className={clsx(classes.root, {
        [classes.secondary]: styleType === 'secondary',
        [classes.disabled]: disabled,
      })}
      {...props}
    >
      {children}
    </MuiLink>
  );
};

export default Link;
